'use client';

import { c as _c } from "react/compiler-runtime";
import { User } from '@algoacademy/design-system/web/actions/User';
import { Badge, type BadgeColor } from '@algoacademy/design-system/web/data-display/Badge';
import { Label4 } from '@algoacademy/design-system/web/typography/Label';
import { pluralizePl } from '@/app/app/_utils/pluralizePl';
import { getAccessPreviewVisibleCount } from './get-access-preview-visible-count';
import type { CollectionAccessPreviewItem } from './types';
type AccessPreviewRowProps = {
  items: CollectionAccessPreviewItem[];
};
function AccessPreviewItem(t0) {
  const $ = _c(9);
  const {
    item
  } = t0;
  if (item.kind === "role") {
    const t1 = item.role.badgeColor as BadgeColor;
    let t2;
    if ($[0] !== item.role.role) {
      t2 = <span className="truncate">{item.role.role}</span>;
      $[0] = item.role.role;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <Badge color={t1} className="max-w-xs">{t2}</Badge>;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t1 = item.user.fullName ?? item.user.email;
  const t2 = item.user.imageUrl ?? null;
  let t3;
  if ($[5] !== item.user.accentColor || $[6] !== t1 || $[7] !== t2) {
    t3 = <User fullname={t1} src={t2} accentColor={item.user.accentColor} tiny={true} truncateFullname={true} className="max-w-xs" />;
    $[5] = item.user.accentColor;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export function AccessPreviewRow(t0) {
  const $ = _c(16);
  const {
    items
  } = t0;
  if (items.length === 0) {
    return null;
  }
  let hiddenCount;
  let t1;
  let t2;
  let t3;
  if ($[0] !== items) {
    const visibleCount = getAccessPreviewVisibleCount(items);
    hiddenCount = items.length - visibleCount;
    const visibleItems = items.slice(0, visibleCount);
    t3 = "flex min-w-0 items-center gap-3";
    t1 = "flex min-w-0 flex-1 flex-nowrap items-center gap-3";
    let t4;
    if ($[5] !== visibleCount) {
      t4 = item => <div key={item.id} className={visibleCount === 1 ? "min-w-0 max-w-full shrink" : "shrink-0"}><AccessPreviewItem item={item} /></div>;
      $[5] = visibleCount;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t2 = visibleItems.map(t4);
    $[0] = items;
    $[1] = hiddenCount;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    hiddenCount = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hiddenCount) {
    t5 = hiddenCount > 0 && <Label4 className="shrink-0 text-contentTertiary">+{hiddenCount}{" "}{pluralizePl(hiddenCount, {
        one: "inna",
        few: "inne",
        many: "innych"
      })}</Label4>;
    $[10] = hiddenCount;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}